// Parses PoE filter string-list values such as:
//   "Chaos Orb" "Divine Orb"
//   Rings Amulets
// Quoted tokens stay intact (including spaces); unquoted tokens split on whitespace.
export function parseFilterStringList(value: string): string[] {
  const trimmed = value.trim();
  if (!trimmed) {
    return [''];
  }

  const result: string[] = [];
  const tokenRegex = /"([^"]*)"|[^\s"]+/g;
  let match: RegExpExecArray | null;
  while ((match = tokenRegex.exec(trimmed)) !== null) {
    result.push(match[1] !== undefined ? match[1] : match[0]);
  }

  return result.length > 0 ? result : [trimmed];
}
